// extracted by mini-css-extract-plugin
export default {"footer":"F_cx","footer_logo":"F_cy","navLinks":"F_cz","column":"F_cB","columnHeading":"F_cC","copyright":"F_cD","socialMediaLinks":"F_cF"};